import React, { Fragment, useEffect, useRef, useState } from "react";
import { Circle, Popup } from "react-leaflet";
import { Header } from "semantic-ui-react";
import { useBool } from "../../../sg-hooks/useBool";
import { TMapAuditingCheck } from "../IMapAuditing";
import { MapAuditingCheckDetail } from "./MapAuditingCheckDetail";
import { MapAuditingCheckForm } from "./MapAuditingCheckForm";

const Colors = {
    Green: "#349b34",
    Red: "#c04242",
    Grey: "#676767",
    LightBlue: "#918f00"

};

interface MapAuditingProps {
    title: string;
    checkItem: TMapAuditingCheck;
    onChange?: (checkData: TMapAuditingCheck) => void;
    onRemove?: () => void;
    interactive?: boolean
};

export const MapAuditingMarker: React.FC<MapAuditingProps> = ({
    title,
    checkItem,
    onChange,
    onRemove,
    interactive = true
}) => {

    const [popupOpen, setPopupOpen] = useState(false)
    const popupEl = useRef<any>(null)

    const color =
        checkItem.status === "kunnossa" ? Colors.Green
            : checkItem.status === "korjattavaa" ? Colors.Red
                : checkItem.fixed ? Colors.Grey : Colors.LightBlue

    const closePopup = () => {
        if (popupEl.current && popupEl.current?.leafletElement._close instanceof Function) {
            popupEl.current?.leafletElement._close();
        };
    };

    const submit = (checkData: TMapAuditingCheck) => {
        if (onChange) {
            onChange(checkData)
        };
        closePopup();
    };


    useEffect(() => {
        if (!interactive && popupEl.current?.leafletElement?._container) {
            popupEl.current?.leafletElement._close();
        }
    }, [interactive, popupEl])

    return (
        <Circle
            interactive={interactive}
            center={checkItem.coordinates}
            radius={40 * 1000}
            weight={1}
            dashArray="1 6"
            color={color}
            fillOpacity={0.5}
        >
            <Popup
                key={title}
                ref={popupEl}
                onOpen={() => setPopupOpen(true)}
                onClose={() => setPopupOpen(false)}
                className="MapAuditingMarker-popup"
                closeOnClick={false}
            >
                {popupOpen && (
                    <Fragment>
                        <Header content={title} />
                        {onChange ? (
                            <MapAuditingCheckForm
                                key={title}
                                initialFormData={checkItem}
                                onSubmit={submit}
                                onCancel={closePopup}
                                onRemove={onRemove && !checkItem.fixed ? onRemove : undefined}
                            />
                        ) : (
                            < MapAuditingCheckDetail
                                formData={checkItem}
                                onCancel={closePopup}
                            />
                        )}

                    </Fragment>
                )}
            </Popup>
        </Circle>
    )
};
